import { IBanner, INetworkConfig, IResponse, ISuccessResponse, LanguageAlphabet } from '@/types'
import { Endpoints } from '../endpoints'
import { Instance } from '../instance'

const config: INetworkConfig = {
  baseURL: Endpoints.Base,
}

class Banner extends Instance {
  constructor(config: INetworkConfig) {
    super(config)
  }

  getBanner = (language?: LanguageAlphabet): Promise<IResponse<IBanner>> =>
    this.get(`${Endpoints.GetBanner}`, language ? { headers: { language } } : undefined)

  editBanner = (params: IBanner): Promise<IResponse<ISuccessResponse>> => this.put(Endpoints.EditBanner, params)
}

export const bannerApi = new Banner(config)
